import { ReactNode } from 'react'
import { Modal } from './Modal'
import { Button } from './Button'

interface ConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  children: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  variant?: 'danger' | 'primary'
  isPending?: boolean
}

/**
 * Standard confirmation dialog for destructive or money-moving actions.
 * Replaces native `confirm()` so styling and pending states are consistent.
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  isPending = false,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <div className="font-inter text-body-sm text-stone-600">{children}</div>
      <div className="mt-6 flex justify-end gap-3">
        <Button variant="secondary" type="button" onClick={onClose} disabled={isPending}>
          {cancelLabel}
        </Button>
        <Button variant={variant} type="button" onClick={onConfirm} disabled={isPending}>
          {isPending ? 'Working…' : confirmLabel}
        </Button>
      </div>
    </Modal>
  )
}
